import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['voucherInput']

  focusVoucher () {
    this.voucherInputTarget.focus()
  }
}
